<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // STYLING
    import 'tailwindcss/tailwind.css';

    // CASSIOPEIA
    import {
        AddressItem,
        AddressForm,
        AddressList,
        Button,
        Heading,
        OutputAddress,
    } from '@smatch/cassiopeia-web-components';

    // TYPES
    import type { FormComponentLegacy } from 'src/app/types';

    /* PROPS ----------------------------------------------------------------------------------- */

    export let organizationKey: string;

    /* INTERNALS ------------------------------------------------------------------------------- */

    let Form: FormComponentLegacy | null = null;
    let showEditForm = false;

    const toggle = (): void => {
        showEditForm = !showEditForm;
    };


    /* INTERFACE ------------------------------------------------------------------------------ */

    export const submit = async (): Promise<void> => {
        await (Form as FormComponentLegacy).submit();
    };
    export const isValid = (): boolean => (Form as FormComponentLegacy).isValid();

</script>

<div class = 's8-invoice-address'>

    <AddressList
        parameters = { { addressType: 'invoice', limit: 1, organizationKey, states: [ 'created', 'approved' ] } }
        let:addresses
    >

        <!-- TODO: Fix slot types -->
        <!-- eslint-disable @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access -->

        <div class = 's8-header'>

            <Heading size = 'md'>Invoice Address</Heading>

            <Button
                on:click = { toggle }
                color = { showEditForm ? 'neutral' : 'dark' }
                size = 'xs'
                label = { showEditForm ? 'Cancel' : 'Edit' }
            />

        </div>

        <AddressItem key = { addresses[0]._.key } let:address>

            {#if showEditForm || address._.state === 'created'}
                <AddressForm
                    { address }
                    action = 'update'
                    on:cancel = { toggle }
                    on:save = { toggle }
                    showCancel
                    bind:this = { Form }
                    { organizationKey }
                />
            {:else}
                <OutputAddress { address } mode = 'full'/>
            {/if}

        </AddressItem>

        <svelte:fragment slot = 'empty'>
            <div class = 's8-empty-container'>
                <Heading size = 'md'>Invoice Address</Heading>
                <AddressForm
                    action = 'create'
                    address = { { type: 'invoice' } }
                    bind:this = { Form }
                    { organizationKey }
                />
            </div>
        </svelte:fragment>

        <!-- eslint-enable -->

    </AddressList>

</div>

<style lang="postcss">

    div.s8-invoice-address {

        div.s8-header {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
        }

        :global(address) {
            padding-bottom: 20px;
            line-height: 1.6;
        }

        :global(div.s8-buttons) {
            display: none !important;
        }
    }

</style>